// show "reload cart button" if quantity in cart was changed

$(document).ready(function() {
    $('.shop__item--input').on('change keyup paste', function() {

        $('.btn--reload').addClass('shop__item--input-change');
        $('.shop__cart .icon-enabled').addClass('disabled');
    });
});
